import React from 'react';

import { Field, Label, Suggestion, SuggestionItem, SuggestionProps } from '@innovationnorway/cl-react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type FilterProps = {
  queryStringParam: string;
  label?: string;
  options: SuggestionItem[];
  placeHolder?: string;
  className?: string;
} & Omit<SuggestionProps, 'value'> &
  React.RefAttributes<HTMLDivElement>;

const QueryParamMultiSelect = (props: FilterProps) => {
  const { queryStringParam, options } = props;
  const { t: tCommon } = useTranslation('common');
  const [searchParams, setSearchParams] = useSearchParams();

  const onChange = (selected: SuggestionItem[]) => {
    const params = selected.map((item) => item.value);
    if (params.length === 0) {
      searchParams.delete(queryStringParam);
    } else {
      searchParams.set(queryStringParam, params.join(','));
    }
    setSearchParams(searchParams);
  };

  return (
    <Field className={props.className}>
      <Label>{props.label}</Label>
      <Suggestion
        multiple
        className="flex-basis--20"
        onSelectedChange={(selected) => onChange(selected)}
        selected={props.options.filter((option) =>
          searchParams.get(queryStringParam)?.includes(option.value),
        )}
      >
        <Suggestion.Input placeholder={props.placeHolder || tCommon('choose')}></Suggestion.Input>

        <Suggestion.Clear></Suggestion.Clear>
        <Suggestion.List>
          <Suggestion.Empty>Ingen tilgjengelige filter</Suggestion.Empty>
          {options.map((option) => (
            <Suggestion.Option value={option.value} key={queryStringParam + option.value}>
              {option.label}
            </Suggestion.Option>
          ))}
        </Suggestion.List>
      </Suggestion>
    </Field>
  );
};

export default QueryParamMultiSelect;
